import type { ReactNode } from "react";
import { Card } from "./Card";

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return <div className="py-10 text-center text-sm text-ink-soft">{label}</div>;
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <Card className="border-signal-300 bg-signal-50 px-5 py-4">
      <p className="text-sm text-signal-600">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 text-sm font-medium text-signal-600 underline underline-offset-2"
        >
          Try again
        </button>
      )}
    </Card>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <Card className="flex h-32 items-center justify-center px-5 text-center text-sm text-ink-soft">
      {children}
    </Card>
  );
}

/** Marks a section as showing data that isn't live yet -- the underlying
 * automation (telephony ingestion, SMS/AI) hasn't been built, so what's
 * shown is real D1 data seeded/entered by hand rather than a fabricated
 * mock in the frontend. Distinct from `PlaceholderNotice`, which marks UI
 * with no real data behind it at all. */
export function DemoDataNotice({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-md border border-dashed border-line bg-paper px-4 py-3 text-sm text-ink-soft">
      {children}
    </div>
  );
}
